import React from "react";
import "./Navigation.css";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const Navigation = () => {
  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        className="navbar-container"
        sticky="top"
      >
        <Container>
          <Navbar.Brand as={Link} to="/">
            <Navbar.Brand className="text-white">
              Tahmid's <span className="text-danger fw-bold">Portfolio</span>
            </Navbar.Brand>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            style={{ backgroundColor: "#dc3545" }}
          />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link className="fw-bolder text-white ps-3" as={Link} to="/">
                Portfolio
              </Nav.Link>
              <Nav.Link
                className="fw-bolder text-white ps-3"
                as={Link}
                to="/about"
              >
                About Me
              </Nav.Link>
              <Nav.Link
                className="fw-bolder text-white ps-3"
                as={Link}
                to="/allProjects"
              >
                Projects
              </Nav.Link>
              <Nav.Link
                className="fw-bolder text-white ps-3"
                as={Link}
                to="/blogs"
              >
                Blogs
              </Nav.Link>
              <Nav.Link
                className="fw-bolder text-white ps-3"
                as={Link}
                to="/contact"
              >
                Contact
              </Nav.Link>
              <button className="btn btn-danger ps-3">
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="https://drive.google.com/file/d/1zjs4MJ4FqkT6a17FFhtNgdYnZERUIOlg/view?usp=sharing"
                  target="_blank"
                  rel="noreferrer"
                >
                  Download Resume
                </a>
              </button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Navigation;
